import React from 'react';
import { Table, Tooltip, Tag, Popover, Button } from 'antd';
import {LinkedinOutlined, ChromeOutlined} from "@ant-design/icons";

const ContactPopup = ({ links }) => {
  const content = (
    <div>
      {links.map((link, index) => (
        <p key={index}>
          {link.includes("linkedin") ? (
            <a href={link} target="_blank" rel="noopener noreferrer">
              <LinkedinOutlined /> {link}
            </a>
          ) : link.includes("@") ? (
            <a href={`mailto:${link}`} target="_blank" rel="noopener noreferrer">
              <ChromeOutlined /> {link}
            </a>
          ) : (
            <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
          )}
        </p>
      ))}
    </div>
  );

  return (
    <Popover content={content} title="Contact Links" trigger="click">
      <Button type="link">View Contacts</Button>
    </Popover>
  );
};

const parseAUM = (aum) => {
  return Number(aum.replace(/[^0-9.-]+/g,"")) * (aum.includes('billion') ? 1000 : 1);
};



const LeadList = ({ data }) => {
  const columns = [
    {
      title: 'Firm Name',
      dataIndex: 'firm_name',
      key: 'firm_name',
    },
    {
      title: 'AUM',
      dataIndex: 'aum',
      key: 'aum',
      sorter: (a, b) => parseAUM(a.aum) - parseAUM(b.aum),
    },
    {
      title: 'Branch Phone',
      dataIndex: 'branch_phone',
      key: 'branch_phone',
    },
    {
      title: 'Custodians',
      dataIndex: 'custodians',
      key: 'custodians',
      render: custodians => (
        <>
          {custodians.map(custodian => (
            <Tag color="blue" key={custodian}>
              {custodian}
            </Tag>
          ))}
        </>
      ),
    },
    {
      title: 'Contact Links',
      dataIndex: 'contact_links',
      key: 'contact_links',
      render: links => <ContactPopup links={links} />,
    },
    {
      title: 'Head Count',
      dataIndex: 'head_count',
      key: 'head_count',
      sorter: (a, b) => a.head_count - b.head_count,

    }
  ];

  return (
    <Table columns={columns} dataSource={data} rowKey="firm_name" />
  );
};

export default LeadList;
